import { addDays } from './add-days';
import { getMonday } from './get-monday';

export function getEndOfWeek(epoch: number): number {
  const date = getMonday(epoch);

  return addDays(date, 7);
}
